import React, { useState } from "react";
import { MagicWand } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { NewUserWizard } from "@/components/user-wizard/NewUserWizard";

const STYLES = {
  solid: "inline-flex items-center gap-2 border border-black bg-black px-3 py-2 text-xs uppercase tracking-widest text-white transition-transform duration-100 hover:translate-x-[2px] hover:translate-y-[2px]",
  nav: "flex w-full items-center gap-3 border-l-4 border-transparent px-4 py-3 text-left text-zinc-900 transition-colors duration-100 hover:border-black hover:bg-zinc-100",
};

// Opens the new-user wizard; only shown to internal staff who can add some kind of login.
export function NewUserWizardButton({ variant = "solid", testId = "new-user-wizard-btn" }) {
  const { user, hasPerm } = useAuth();
  const [open, setOpen] = useState(false);
  const can = user?.org_type === "internal" && ["manage_employees", "manage_routing", "manage_affiliates"].some((p) => hasPerm(p));
  if (!can) {
    return null;
  }
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className={STYLES[variant]} data-testid={testId}>
        <MagicWand size={variant === "nav" ? 18 : 14} weight="bold" />
        <span className={variant === "nav" ? "text-[13px] font-medium tracking-tight" : ""}>New user wizard</span>
      </button>
      <NewUserWizard open={open} onClose={() => setOpen(false)} />
    </>
  );
}
